import React, { useState } from 'react';
import { useT } from '@repo/common';
import { ReactComponent as WarningIcon } from '@repo/common/assets/icons/20px/icon_20px_warning_filled.svg';
import { ReactComponent as CloseIcon } from '@repo/common/assets/icons/16px/icon_16px_cancel.svg';

export default function AccountChangeBanner({ notice, onDismiss }) {
  const t = useT();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  if (!notice) return null;
  const changedAt = new Date(notice.changedAt);
  if (Number.isNaN(changedAt.getTime())) return null;
  const date = changedAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const time = changedAt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  const message = notice.kind === 'BUSINESS_REMOVED'
    ? t(`Your account was changed to a personal account on ${date} at ${time}.`, `${date} ${time}에 개인 계정으로 변경되었습니다.`)
    : t(`Your Creator role was removed on ${date} at ${time}.`, `${date} ${time}에 크리에이터 권한이 해제되었습니다.`);
  return (
    <div className='w-full'>
      <div role='status' className='flex w-full items-center gap-1.5 rounded-lg border border-functional-warning03 bg-functional-warning01 px-3 py-2.5'>
        <div className='flex min-w-0 flex-1 items-start gap-1.5'>
          <span className='flex h-[30px] w-5 shrink-0 items-center text-text-warning'><WarningIcon /></span>
          <p className='flex min-h-[30px] min-w-0 items-center typo-b12Strong text-text-warning'>{message}</p>
        </div>
        <div className='flex shrink-0 items-center gap-2'>
          <a href='mailto:hello@ko-ready.com' className='rounded-full bg-[rgba(255,178,0,0.15)] px-3 py-1.5 typo-b13Strong text-text-placeholder hover:text-text-primary'>{t('Contact', '문의')}</a>
          <button type='button' disabled={pending} aria-label={t('Dismiss account change notice', '계정 변경 알림 닫기')} className='flex size-[30px] items-center justify-center text-text-primary disabled:opacity-50' onClick={async () => {
            setPending(true);
            setError(false);
            try { await onDismiss(notice.id); } catch { setError(true); } finally { setPending(false); }
          }}><CloseIcon /></button>
        </div>
      </div>
      {error && <p role='alert' className='mt-1 typo-b12 text-text-secondary'>{t('Could not dismiss the notice. Please try again.', '알림을 닫지 못했습니다. 다시 시도해 주세요.')}</p>}
    </div>
  );
}
